<div class="container-div">
  <cds-tile class="header" [ngClass]="dealerImageDetails?.url ? 'header-with-image':'header-without-image'">
    <div class="header-image">
      @if (dealerImageDetails?.url) {
        <img [src]=[dealerImageDetails?.url] alt='File not found.' i18n-alt />
      }
    </div>
    <div class="header-text">
      <div class="request-text" i18n>Service Authorization Request</div>
      <div class="user-name-model">
        <div class="user-name"> {{customerName}} </div>
        <div class="vehicle-model"> {{modelName}} </div>
      </div>

    </div>
  </cds-tile>
  @if (serviceJobs.length > 1) {
    <mat-card class="cost-of-work-container" appearance="outlined">
      <mat-card-content class="cost-of-work-body">
        <div >
          <ng-container i18n>Cost of Work</ng-container>
          <span (click)="costOfWorkInfo()" class="custom-icon">
            <img src="../../assets/common/info.svg" alt='File not found.' i18n-alt>
          </span>
        </div>
        <div>
          @if (costOfWork) {
            <div>{{costOfWork|
            currency:currencyCode:'symbol-narrow'}}</div>
          }
          @if (!costOfWork) {
            <div>{{0|
            currency:currencyCode:'symbol-narrow'}}</div>
          }
        </div>
      </mat-card-content>
    </mat-card>
  }
  @if (serviceJobs.length != 0 && !isServiceJobs) {
    <div class="parent-div">
      <div class="scrollableTile" [ngClass]="{'scrollableTile-without-approve-all-decline-all-buttons': !(serviceJobs.length > 1 && showApproveAllOrDeclineAllButtons)}">
        @if (serviceJobs.length > 1) {
          <mat-card class="cost-of-work-container-large" appearance="outlined">
            <mat-card-content class="cost-of-work-body-large">
              <div>
                <ng-container i18n>Cost of Work</ng-container>
                <span (click)="costOfWorkInfo()" class="custom-icon">
                  <img src="../../assets/common/info.svg" alt='File not found.' i18n-alt>
                </span>
              </div>
              <div>
                @if (costOfWork) {
                  <div>{{costOfWork|
                  currency:currencyCode:'symbol-narrow'}}</div>
                }
                @if (!costOfWork) {
                  <div>{{0|
                  currency:currencyCode:'symbol-narrow'}}</div>
                }
              </div>
            </mat-card-content>
          </mat-card>
        }
        @for (jobData of serviceJobs; track jobData; let i = $index) {
          <cds-tile class="container-body" fluid
            (click)="onSelectedTile(jobData,i)">
            <div class="body-content" [ngClass]="{'clicked': clickedStates[i]}">
              <div>
                <div>
                  @if (jobData.checkpoints) {
                    <div class="radio-button">
                      @if (jobData.checkpoints[0].status === 'NotOK') {
                        <div>
                          @if (checkRadioButtonColor(jobData.checkpoints[0],'yellow')) {
                            <img src="../../assets/common/radio-buttons/not-ok.svg" alt="File not found." i18n-alt>
                          }
                          @if (checkRadioButtonColor(jobData.checkpoints[0],'red')) {
                            <img src="../../assets/common/radio-buttons/not-ok-red.svg" alt="File not found." i18n-alt>
                          }
                        </div>
                      }
                      @if (jobData.checkpoints[0].status === 'OK') {
                        <img src="../../assets/common/radio-buttons/ok.svg" alt="File not found." i18n-alt>
                      }
                      @if (jobData.checkpoints[0].status === 'Undefined') {
                        <img src="../../assets/common/radio-buttons/Undefined.svg" alt="File not found." i18n-alt>
                      }
                    </div>
                  }
                  @if (!jobData.checkpoints && serviceJobs.length !== 0 && !isServiceJobs) {
                    <div class="radio-button"
                      >
                      <svg class="radio-input" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none">
                        <path
                          d="M12 1.5C9.9233 1.5 7.89323 2.11581 6.16652 3.26957C4.4398 4.42332 3.09399 6.0632 2.29927 7.98182C1.50455 9.90045 1.29661 12.0116 1.70176 14.0484C2.1069 16.0852 3.10693 17.9562 4.57538 19.4246C6.04383 20.8931 7.91476 21.8931 9.95156 22.2982C11.9884 22.7034 14.0996 22.4955 16.0182 21.7007C17.9368 20.906 19.5767 19.5602 20.7304 17.8335C21.8842 16.1068 22.5 14.0767 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5ZM12 21C10.22 21 8.47992 20.4722 6.99987 19.4832C5.51983 18.4943 4.36628 17.0887 3.68509 15.4442C3.0039 13.7996 2.82567 11.99 3.17294 10.2442C3.5202 8.49836 4.37737 6.89471 5.63604 5.63604C6.89472 4.37737 8.49836 3.5202 10.2442 3.17293C11.99 2.82567 13.7996 3.0039 15.4442 3.68508C17.0887 4.36627 18.4943 5.51983 19.4832 6.99987C20.4722 8.47991 21 10.22 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.387 21 12 21Z"
                          fill="#FFA300" />
                          <path
                            d="M12 7.5C11.11 7.5 10.24 7.76392 9.49994 8.25839C8.75992 8.75285 8.18314 9.45566 7.84255 10.2779C7.50195 11.1002 7.41284 12.005 7.58647 12.8779C7.76011 13.7508 8.18869 14.5526 8.81802 15.182C9.44736 15.8113 10.2492 16.2399 11.1221 16.4135C11.995 16.5872 12.8998 16.4981 13.7221 16.1575C14.5443 15.8169 15.2472 15.2401 15.7416 14.5001C16.2361 13.76 16.5 12.89 16.5 12C16.5 10.8065 16.0259 9.66193 15.182 8.81802C14.3381 7.97411 13.1935 7.5 12 7.5Z"
                            fill="#FFA300" />
                          </svg>
                        </div>
                      }
                      @if (jobData.checkpoints) {
                        <div class="item-name-with-price">
                          <div class="item-name">{{jobData.checkpoints[0]?.description}}
                          {{jobData.checkpoints[0]?.findings[0]?.findingType?.description}}</div>
                          @if (!isObjectEmpty(jobData.total)) {
                            <div class="price">{{jobData.price.grossPrice |
                              currency:jobData.price.currency:'symbol-narrow'}}
                            </div>
                          }
                        </div>
                      }
                      @if (!jobData.checkpoints && serviceJobs.length !== 0 && !isServiceJobs) {
                        <div class="item-name-with-price"
                          >
                          <div class="item-name">{{jobData.description}}</div>
                          @if (!isObjectEmpty(jobData.total)) {
                            <div class="price">{{jobData.price.grossPrice |
                              currency:jobData.price.currency:'symbol-narrow'}}
                            </div>
                          }
                        </div>
                      }
                    </div>
                    <div>
                      @if (jobData.checkpoints) {
                        <div class="item-discription">{{jobData.description}}</div>
                      }
                      @if (jobData.checkpoints?.[0]?.comment) {
                        <div class="item-discription">
                          {{jobData.checkpoints?.[0]?.comment}}
                        </div>
                      }
                    </div>
                    <mat-expansion-panel class="expansionTile" [expanded]="panelOpenState[i]">
                      <div class="collapse-discription">
                        {{jobData.descritpionLong}}
                      </div>
                      @if (!isObjectEmpty(jobData.total)) {
                        <div class="price-breakdown-container">
                          @for (priceData of jobData.total; track priceData) {
                            <div class="price-breakdone-loop">
                              <div class="price-breakdown item-price-data">
                                <div i18n>{{(priceData.type | lowercase )}}</div>
                                @if (priceData.price.netPrice) {
                                  <div>{{priceData.price.netPrice|
                                  currency:jobData.price.currency:'symbol-narrow'}}</div>
                                }
                                @if (!priceData.price.netPrice) {
                                  <div>{{0|
                                  currency:jobData.price.currency:'symbol-narrow'}}</div>
                                }
                              </div>
                              <div class="price-breakdown item-discount-price">
                                <div i18n>Discount</div>
                                @if (priceData.price.discount.value) {
                                  <div>{{priceData.price.discount.value |
                                  currency:jobData.price.currency:'symbol-narrow'}}</div>
                                }
                                @if (!priceData.price.discount.value) {
                                  <div>{{0 |
                                  currency:jobData.price.currency:'symbol-narrow'}}</div>
                                }
                              </div>
                              <div class="price-breakdown itrm-total-price">
                                <div i18n>Total</div>
                                @if (priceData.price.grossPrice) {
                                  <div>{{priceData.price.grossPrice |
                                  currency:jobData.price.currency:'symbol-narrow'}}</div>
                                }
                                @if (!priceData.price.grossPrice) {
                                  <div>{{0 |
                                  currency:jobData.price.currency:'symbol-narrow'}}</div>
                                }
                              </div>
                            </div>
                          }
                          <div class="price-breakdown total-vat">
                            <div i18n>VAT</div>
                            @if (jobData.price.taxes[0].value) {
                              <div>{{jobData.price.taxes[0].value |
                              currency:jobData.price.currency:'symbol-narrow'}}</div>
                            }
                            @if (!jobData.price.taxes[0].value) {
                              <div>{{0 |
                              currency:jobData.price.currency:'symbol-narrow'}}</div>
                            }
                          </div>
                        </div>
                      }
                    </mat-expansion-panel>
                    @if (jobData.checkpoints) {
                      <div>
                        @if ((jobData.checkpoints[0]?.findings && jobData.checkpoints[0].findings[0]?.media) || jobData.checkpoints[0].media) {
                          <div class="galary-discription-with-info-icon"
                            >
                            <div class="galary-discription" i18n>Gallery</div>
                            <div>
                            </div>
                          </div>
                        }
                        @if (jobData.checkpoints[0].findings && jobData.checkpoints[0].findings[0]?.media) {
                          <div (swipeleft)="onCarouselSwipe('left', i)" data-bs-touch="false"
                            (panleft)="onCarouselSwipe('left', i)" (swiperight)="onCarouselSwipe('right', i)"
                            (panright)="onCarouselSwipe('right', i)" id="carousel{{i}}"
                            class="carousel slide carouselBlock" data-ride="carousel">
                            <ol class="carousel-indicators">
                              @for (item of jobData.checkpoints[0]?.findings[0]?.media; track item; let j = $index) {
                                <li class="indicators{{i}}"
                                  [class.active]="j === 0" [attr.data-bs-target]="'#carousel' + i"
                                  [attr.data-bs-slide-to]="j">
                                </li>
                              }
                            </ol>
                            <div class="carousel-inner">
                              @for (item of jobData.checkpoints[0]?.findings[0]?.media; track item; let j = $index) {
                                <div class="carousel-item carousel-track-items{{i}} image-slide"
                                  [ngClass]="{ 'carousel-slide-transition': true }"
                                  [class.active]="j === 0">
                                  @if (item.mimeType.includes('Video') && !(jobData.checkpoints[0]?.isWalkthroughEnabled && !isObjectEmpty(introOutroMediaData))) {
                                    <div>
                                      <video width="270" height="140" controls>
                                        <source [src]="item.url" type="video/mp4">
                                        <source [src]="item.url" type="video/ogg">
                                        Your browser does not support the video.
                                      </video>
                                    </div>
                                  }
                                  @if (item.mimeType.includes('Video') && (jobData.checkpoints[0]?.isWalkthroughEnabled && !isObjectEmpty(introOutroMediaData))) {
                                    <div class="video-player-div">
                                      <app-video-player [media]="item" [introOutroMediaData]="introOutroMediaData"></app-video-player>
                                    </div>
                                  }
                                  @if (item.mimeType.includes('Image')) {
                                    <div>
                                      <a (click)="openMediaModal(item.url, item.altText)"><img [src]="item.url"
                                      [alt]="item.altText" class="d-block w-100"></a>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                            @if (jobData.checkpoints[0]?.findings && jobData.checkpoints[0].findings[0]?.media) {
                              <div class="galary-info-icon"
                                >
                                <div class="info-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <g id="Info">
                                    <g id="Vector">
                                      <path d="M12.75 16.5V10.5H9.75V12H11.25V16.5H9V18H15V16.5H12.75Z"
                                        fill="black" />
                                        <path
                                          d="M12 6C11.7775 6 11.56 6.06598 11.375 6.1896C11.19 6.31322 11.0458 6.48892 10.9606 6.69449C10.8755 6.90005 10.8532 7.12625 10.8966 7.34448C10.94 7.56271 11.0472 7.76317 11.2045 7.9205C11.3618 8.07783 11.5623 8.18498 11.7805 8.22839C11.9988 8.2718 12.225 8.24952 12.4305 8.16437C12.6361 8.07922 12.8118 7.93503 12.9354 7.75002C13.059 7.56502 13.125 7.34751 13.125 7.125C13.125 6.82664 13.0065 6.54049 12.7955 6.32951C12.5845 6.11853 12.2984 6 12 6Z"
                                          fill="black" />
                                          <path
                                            d="M12 22.5C9.9233 22.5 7.89323 21.8842 6.16652 20.7304C4.4398 19.5767 3.09399 17.9368 2.29927 16.0182C1.50455 14.0996 1.29661 11.9884 1.70176 9.95156C2.1069 7.91476 3.10693 6.04383 4.57538 4.57538C6.04383 3.10693 7.91476 2.1069 9.95156 1.70176C11.9884 1.29661 14.0996 1.50455 16.0182 2.29927C17.9368 3.09399 19.5767 4.4398 20.7304 6.16652C21.8842 7.89323 22.5 9.9233 22.5 12C22.5 14.7848 21.3938 17.4555 19.4246 19.4246C17.4555 21.3938 14.7848 22.5 12 22.5ZM12 3C10.22 3 8.47992 3.52785 6.99987 4.51678C5.51983 5.50571 4.36628 6.91132 3.68509 8.55585C3.0039 10.2004 2.82567 12.01 3.17294 13.7558C3.5202 15.5016 4.37737 17.1053 5.63604 18.364C6.89472 19.6226 8.49836 20.4798 10.2442 20.8271C11.99 21.1743 13.7996 20.9961 15.4442 20.3149C17.0887 19.6337 18.4943 18.4802 19.4832 17.0001C20.4722 15.5201 21 13.78 21 12C21 9.61306 20.0518 7.32387 18.364 5.63604C16.6761 3.94822 14.387 3 12 3Z"
                                            fill="black" />
                                          </g>
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                            @if (jobData.checkpoints[0] && jobData.checkpoints[0].media) {
                              <div (swipeleft)="onCarouselSwipe('left', i)" data-bs-touch="false"
                                (panleft)="onCarouselSwipe('left', i)" (swiperight)="onCarouselSwipe('right', i)"
                                (panright)="onCarouselSwipe('right', i)" id="carousel{{i}}"
                                class="carousel slide carouselBlock" data-ride="carousel">
                                <ol class="carousel-indicators">
                                  @for (item of jobData.checkpoints[0]?.media; track item; let j = $index) {
                                    <li class="indicators{{i}}"
                                      [class.active]="j === 0" [attr.data-bs-target]="'#carousel' + i"
                                      [attr.data-bs-slide-to]="j">
                                    </li>
                                  }
                                </ol>
                                <div class="carousel-inner">
                                  @for (item of jobData.checkpoints[0]?.media; track item; let j = $index) {
                                    <div class="carousel-item carousel-track-items{{i}} image-slide"
                                      [ngClass]="{ 'carousel-slide-transition': true }"
                                      [class.active]="j === 0">
                                      @if (item.mimeType.includes('Video') && !(jobData.checkpoints[0]?.isWalkthroughEnabled && !isObjectEmpty(introOutroMediaData))) {
                                        <div>
                                          <video width="270" height="140" controls>
                                            <source [src]="item.url" type="video/mp4">
                                            <source [src]="item.url" type="video/ogg">
                                            Your browser does not support the video.
                                          </video>
                                        </div>
                                      }
                                      @if (item.mimeType.includes('Video') && (jobData.checkpoints[0]?.isWalkthroughEnabled && !isObjectEmpty(introOutroMediaData))) {
                                        <div class="video-player-div">
                                          <app-video-player [media]="item" [introOutroMediaData]="introOutroMediaData"></app-video-player>
                                        </div>
                                      }
                                      @if (item.mimeType.includes('Image')) {
                                        <div>
                                          <a (click)="openMediaModal(item.url, item.altText)"><img [src]="item.url"
                                          [alt]="item.altText" class="d-block w-100"></a>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                                @if (jobData.checkpoints[0]?.findings && jobData.checkpoints[0]?.media) {
                                  <div class="galary-info-icon"
                                    >
                                    <div class="info-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <g id="Info">
                                        <g id="Vector">
                                          <path d="M12.75 16.5V10.5H9.75V12H11.25V16.5H9V18H15V16.5H12.75Z"
                                            fill="black" />
                                            <path
                                              d="M12 6C11.7775 6 11.56 6.06598 11.375 6.1896C11.19 6.31322 11.0458 6.48892 10.9606 6.69449C10.8755 6.90005 10.8532 7.12625 10.8966 7.34448C10.94 7.56271 11.0472 7.76317 11.2045 7.9205C11.3618 8.07783 11.5623 8.18498 11.7805 8.22839C11.9988 8.2718 12.225 8.24952 12.4305 8.16437C12.6361 8.07922 12.8118 7.93503 12.9354 7.75002C13.059 7.56502 13.125 7.34751 13.125 7.125C13.125 6.82664 13.0065 6.54049 12.7955 6.32951C12.5845 6.11853 12.2984 6 12 6Z"
                                              fill="black" />
                                              <path
                                                d="M12 22.5C9.9233 22.5 7.89323 21.8842 6.16652 20.7304C4.4398 19.5767 3.09399 17.9368 2.29927 16.0182C1.50455 14.0996 1.29661 11.9884 1.70176 9.95156C2.1069 7.91476 3.10693 6.04383 4.57538 4.57538C6.04383 3.10693 7.91476 2.1069 9.95156 1.70176C11.9884 1.29661 14.0996 1.50455 16.0182 2.29927C17.9368 3.09399 19.5767 4.4398 20.7304 6.16652C21.8842 7.89323 22.5 9.9233 22.5 12C22.5 14.7848 21.3938 17.4555 19.4246 19.4246C17.4555 21.3938 14.7848 22.5 12 22.5ZM12 3C10.22 3 8.47992 3.52785 6.99987 4.51678C5.51983 5.50571 4.36628 6.91132 3.68509 8.55585C3.0039 10.2004 2.82567 12.01 3.17294 13.7558C3.5202 15.5016 4.37737 17.1053 5.63604 18.364C6.89472 19.6226 8.49836 20.4798 10.2442 20.8271C11.99 21.1743 13.7996 20.9961 15.4442 20.3149C17.0887 19.6337 18.4943 18.4802 19.4832 17.0001C20.4722 15.5201 21 13.78 21 12C21 9.61306 20.0518 7.32387 18.364 5.63604C16.6761 3.94822 14.387 3 12 3Z"
                                                fill="black" />
                                              </g>
                                            </g>
                                          </svg>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            }
                            <div (click)="stopEventPropagation($event)" class="backdrop"></div>
                            <div (click)="stopEventPropagation($event)" class="modal" #imageModal tabindex="-1" role="dialog">
                              <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                  <div class="modal-header">
                                    <div class="modal-title"></div>
                                    <button type="button" class="close" (click)="closeMediaModal($event)">
                                      <span>&times;</span>
                                    </button>
                                  </div>
                                  <div class="modal-body">
                                    <img [src]="modalImageUrl" class="d-block w-100" alt="modalImage">
                                  </div>
                                </div>
                              </div>
                            </div>
                            @if (jobData.approvalStatus !== 'Accept' && jobData.approvalStatus !== 'Reject' && !isObjectEmpty(jobData.total)) {
                              <div class="buttons"
                                >
                                <button color="primary" class="button-decline" mat-raised-button
                                (click)="onButtonGroupClick('Reject',jobData)" i18n>Decline</button>
                                <button color="primary" class="button-authorize" mat-raised-button
                                (click)="onButtonGroupClick('Accept',jobData)" i18n>Authorize</button>
                              </div>
                            }
                            @if (jobData.approvalStatus === 'Reject'  && !isObjectEmpty(jobData.total)) {
                              <div class="buttons">
                                <button class="button-decline button-decline-reject" mat-raised-button color="primary" i18n>Declined</button>
                              </div>
                            }
                            @if (jobData.approvalStatus === 'Accept') {
                              <div class="buttons">
                                <button class="button-authorize button-decline-accept" mat-raised-button color="primary" i18n>Authorized</button>
                              </div>
                            }
                          </div>
                          @for (panelState of panelOpenState; track panelState; let j = $index) {
                            <div class="buttons">
                              @if (i===j && (jobData.descritpionLong || !isObjectEmpty(jobData.total))) {
                                <div>
                                  @if (panelOpenState[i]) {
                                    <mat-icon class="navigation-icons"
                                    (click)="togglePanel(i)">keyboard_arrow_up</mat-icon>
                                  }
                                  @if (!panelOpenState[i]) {
                                    <mat-icon class="navigation-icons"
                                    (click)="togglePanel(i)">keyboard_arrow_down</mat-icon>
                                  }
                                </div>
                              }
                            </div>
                          }
                          @if (jobData.approvalStatus === 'Reject') {
                            <div class="tail-declined-status-largescreen" i18n>Declined</div>
                          }
                          @if (jobData.approvalStatus === 'Accept') {
                            <div class="tail-authorized-status-largescreen" i18n>Authorized</div>
                          }
                        </div>
                        <div class="spaceBetweenTiles"></div>
                      </cds-tile>
                    }
                    @if (serviceJobs.length > 1 && showApproveAllOrDeclineAllButtons) {
                      <mat-card
                        class="accept-declean-all-container-large" appearance="outlined">
                        <mat-card-content class="accept-declean-all-body">
                          <div>
                            <button (click)="onApproveAllOrDeclineAllClick('Reject')" mat-button i18n>Decline all</button>
                          </div>
                          <div>
                            <button class="authorize-all-button" (click)="onApproveAllOrDeclineAllClick('Accept')"
                            mat-button i18n>Authorize all</button>
                          </div>
                        </mat-card-content>
                      </mat-card>
                    }
                  </div>
                  @if (serviceJobs.length) {
                    <div class="show-block">
                      <mat-card class="mat-card">
                        <div class="mat-container">
                          <div class="details">
                            <div class="captiontop">
                              <span class="Caption">{{selectedJob.description}}</span>
                            </div>
                            <div class="spaceBtwDescription"></div>
                            <div class="Caption-desc">
                              {{selectedJob.descritpionLong}}
                            </div>
                            @if (selectedJob.checkpoints?.[0]?.comment) {
                              <div class="Caption-desc">
                                {{selectedJob.checkpoints?.[0].comment}}
                              </div>
                            }
                            @if (!isObjectEmpty(selectedJob.total)) {
                              <div class="price-breakdown-container">
                                <div class="price-breakdown-container">
                                  @for (priceData of selectedJob.total; track priceData) {
                                    <div class="price-breakdone-loop">
                                      <div class="price-breakdown item-price-data">
                                        <div i18n>{{(priceData.type | lowercase )}}</div>
                                        @if (priceData.price.netPrice) {
                                          <div>{{priceData.price.netPrice|
                                          currency:selectedJob.price.currency:'symbol-narrow'}}</div>
                                        }
                                        @if (!priceData.price.netPrice) {
                                          <div>{{0|
                                          currency:selectedJob.price.currency:'symbol-narrow'}}</div>
                                        }
                                      </div>
                                      <div class="price-breakdown item-discount-price">
                                        <div i18n>Discount</div>
                                        @if (priceData.price.discount.value) {
                                          <div>{{priceData.price.discount.value |
                                          currency:selectedJob.price.currency:'symbol-narrow'}}</div>
                                        }
                                        @if (!priceData.price.discount.value) {
                                          <div>{{0 |
                                          currency:selectedJob.price.currency:'symbol-narrow'}}</div>
                                        }
                                      </div>
                                      <div class="price-breakdown itrm-total-price">
                                        <div i18n>Total</div>
                                        @if (priceData.price.grossPrice) {
                                          <div>{{priceData.price.grossPrice |
                                          currency:selectedJob.price.currency:'symbol-narrow'}}</div>
                                        }
                                        @if (!priceData.price.grossPrice) {
                                          <div>{{0 |
                                          currency:selectedJob.price.currency:'symbol-narrow'}}</div>
                                        }
                                      </div>
                                    </div>
                                  }
                                  <div class="price-breakdown total-vat">
                                    <div i18n>VAT</div>
                                    @if (selectedJob.price.taxes[0].value) {
                                      <div>{{selectedJob.price.taxes[0].value |
                                      currency:selectedJob.price.currency:'symbol-narrow'}}</div>
                                    }
                                    @if (!selectedJob.price.taxes[0].value) {
                                      <div>{{0 |
                                      currency:selectedJob.price.currency:'symbol-narrow'}}</div>
                                    }
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                          <div class="vertical"></div>
                          <div class="image-container">
                            <h4 class="LargeGallerDescription" i18n>Gallery</h4>
                            @if (hasMediaItems()) {
                              <div class="large-images">
                                @if (selectedImageIsImage) {
                                  <a (click)="openMediaModal(smallImagesUrl, smallImagesAlt)"><img [src]="smallImagesUrl"
                                  [alt]="smallImagesAlt"></a>
                                }
                                @if (selectedImageIsVideo) {
                                  @if (!(selectedJob.checkpoints[0]?.isWalkthroughEnabled && !isObjectEmpty(introOutroMediaData))) {
                                    <video width="270" height="140" controls id="videos" #video>
                                      <source [src]="smallImagesUrl" type="video/mp4">
                                      <source [src]="smallImagesUrl" type="video/ogg">
                                      Your browser does not support the video.
                                    </video>
                                  }
                                  @if ((selectedJob.checkpoints[0]?.isWalkthroughEnabled && !isObjectEmpty(introOutroMediaData) && selectedMedia)) {
                                    <div class="video-player-large-div">
                                      <app-video-player [media]="selectedMedia" [introOutroMediaData]="introOutroMediaData"></app-video-player>
                                    </div>
                                  }
                                }
                              </div>
                            }
                            @if (!hasMediaItems()) {
                              <div class="large-images">
                                <img src="../../assets/logo/Frame 84.png" alt="" />
                              </div>
                            }
                            <div style="margin-top: 1rem;"></div>
                            @if (hasMediaItems()) {
                              <div class="small-images" [ngClass]="{'scrollable': hasManyMediaItems()}">
                                @for (item of selectedJob.checkpoints[0]?.findings[0]?.media; track item; let j = $index) {
                                  <div
                                    (click)="onMediaItemClicked(j, item)" [class.highlight]="j === selectedMediaIndex">
                                    @if (item.mimeType.includes('Image')) {
                                      <div>
                                        <img [src]="item.url" [alt]="item.altText">
                                      </div>
                                    }
                                    @if (item.mimeType.includes('Video')) {
                                      <div>
                                        <img [src]="item.thumbnail.url" [alt]="item.altText">
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            }
                            @if (hasMediaItems()) {
                              <div class="small-images" [ngClass]="{'scrollable': hasManyMediaItems()}">
                                @for (item of selectedJob.checkpoints[0]?.media; track item; let j = $index) {
                                  <div
                                    (click)="onMediaItemClicked(j, item)" [class.highlight]="j === selectedMediaIndex">
                                    @if (item.mimeType.includes('Image')) {
                                      <div>
                                        <img [src]="item.url" [alt]="item.altText">
                                      </div>
                                    }
                                    @if (item.mimeType.includes('Video')) {
                                      <div>
                                        <img [src]="item.thumbnail.url" [alt]="item.altText">
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            }
                            @if (!hasMediaItems()) {
                              <div class="NomediaSmallblock">
                              </div>
                            }
                          </div>
                        </div>
                        @if (selectedJob.approvalStatus !== 'Accept' && selectedJob.approvalStatus !== 'Reject' && !isObjectEmpty(selectedJob.total)) {
                          <div class="largebuttons"
                            >
                            <button color="primary" class="button-decline" mat-raised-button
                            (click)="onButtonGroupClick('Reject', selectedJob)" i18n>Decline</button>
                            <button color="primary" class="button-authorize" mat-raised-button
                            (click)="onButtonGroupClick('Accept', selectedJob)" i18n>Authorize</button>
                          </div>
                        }
                        @if (selectedJob.approvalStatus === 'Reject' && !isObjectEmpty(selectedJob.total)) {
                          <div class="largebuttonscompleted">
                            <button class="button-decline button-decline-reject" mat-raised-button color="primary" i18n>Declined</button>
                          </div>
                        }
                        @if (selectedJob.approvalStatus === 'Accept') {
                          <div class="largebuttonscompleted">
                            <button class="button-authorize button-decline-accept" mat-raised-button color="primary" i18n>Authorized</button>
                          </div>
                        }
                      </mat-card>
                    </div>
                  }
                </div>
              }

              @if (serviceJobs.length > 1 && showApproveAllOrDeclineAllButtons) {
                <mat-card class="accept-declean-all-container"
                  appearance="outlined">
                  <mat-card-content class="accept-declean-all-body">
                    <div>
                      <button (click)="onApproveAllOrDeclineAllClick('Reject')" mat-button i18n>Decline all</button>
                    </div>
                    <div>
                      <button class="authorize-all-button" (click)="onApproveAllOrDeclineAllClick('Accept')"
                      mat-button i18n>Authorize all</button>
                    </div>
                  </mat-card-content>
                </mat-card>
              }

              @if (serviceJobs.length === 0 && isServiceJobs) {
                <div class="no-data" i18n>No jobs available</div>
              }
            </div>